/**
 * stacktraceNS のエントリポイント (en)。
 *
 * defaultNS の ParseKeys 肥大化による tsgo TS2859 を回避するため、
 * stacktrace 系機能の翻訳キーは defaultNS から切り出してこの namespace で管理する。
 */
import { pagesIssuesEn } from './stacktrace/issues/issues';
import { pagesProductRoadmapEn } from './stacktrace/product-roadmap/product-roadmap';
import { pagesProductionEn } from './stacktrace/production/production';
import { pagesProductsEn } from './stacktrace/products/products';
import { pagesTestAssetsEn } from './stacktrace/test-assets/test-assets';
import { pagesTestSetsEn } from './stacktrace/test-sets/test-sets';
import { pagesTestSuitesEn } from './stacktrace/test-suites/test-suites';
import { pagesTicketsEn } from './stacktrace/tickets/tickets';
import { pagesValuesEn } from './stacktrace/values/values';

const stacktraceEn = {
  issues: pagesIssuesEn,
  productRoadmap: pagesProductRoadmapEn,
  production: pagesProductionEn,
  products: pagesProductsEn,
  testAssets: pagesTestAssetsEn,
  testSets: pagesTestSetsEn,
  testSuites: pagesTestSuitesEn,
  tickets: pagesTicketsEn,
  values: pagesValuesEn,
} as const;

export default stacktraceEn;
